import { useMemo } from 'react';
import { usePricingCatalogAcquisition } from '../../services/pricingCatalog';
import { mapAcquisitionOfferToCompleteProfilePlan } from './plans';

// CompleteProfile sempre usa o catálogo via GET /pricing-catalog/acquisition,
// sem coupon (CompleteProfile não varia preço por cupom).
export function useCompleteProfilePlans() {
  const {
    offers,
    isLoading: isPricingCatalogLoading,
    isError: isPricingCatalogError,
    refetch,
  } = usePricingCatalogAcquisition({ enabled: true });

  const apiPlans = useMemo(
    () => (offers || []).map(mapAcquisitionOfferToCompleteProfilePlan),
    [offers],
  );

  const isResolved = !isPricingCatalogLoading;

  return {
    plans: isResolved ? apiPlans : [],
    isResolved,
    isError: isPricingCatalogError,
    refetch,
  };
}
